import { service } from "../../../services";

const state = {
  outlet: null,
  error: null,
  loading: false
};

const mutations = {
  setOutlet(state, outlet) {
    state.outlet = outlet;
  },

  setLoading(state, loading) {
    state.loading = loading;
  },

  setError(state, error) {
    state.error = error;
  }
};

const actions = {
  async fetchAllOutlets({ commit }) {
    try {
      const res = await service.get("/outlets");
      return res.items;
    } catch (err) {
      commit("setError", err.message);
    }
  },

  async fetchOutlet({ commit }, payload) {
    try {
      const res = await service.get(`/outlets/${payload.id}`);
      return res;
    } catch (err) {
      commit("setError", err.message);
    }
  },

  async createOutlet({ commit }, payload) {
    console.log(payload);
    try {
      const outlet = await service.put(`/outlets/${payload.id}`, payload);
      console.log(outlet);
      commit("setOutlet", outlet);
    } catch (err) {
      commit("setError", err.message);
    }
  }
};

export const outlets = {
  namespaced: true,
  state,
  actions,
  mutations
};
